import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'priming'

export const dataPointDefinition = {
  retracedId: 'priming',
  name: 'Priming',
  description: '',
  meta: {
    slcpMeta: {
      key: 'fp-pi-3-4',
      number: 'FP-PRO-5-4',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'fp-pro-6',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'Facility Profile',
      verificationSelectionOptList: 'verf-f-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[1],fp-pi-2-1',
      machineShowHide: '[1],fp-pi-2-1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-pi-3-4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 28250,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
